import { IFiltroDiarioClasse } from "@deltasge/marauders-map";

export enum ActionTypes {
  SET = "@config-papeis-padrao/SET",
}

export type IConfigPapelPadrao = Pick<
  IFiltroDiarioClasse,
  | "papel"
  | "width"
  | "height"
  | "marginBottom"
  | "marginLeft"
  | "marginRight"
  | "marginTop"
  | "orientacao"
>;
